<div class="flex flex-col items-center mx-auto overflow-y-auto w-full h-full p-0.5">
  <div class="w-full space-y-4">
    <p class="text-3xl font-light leading-tight tracking-normal">
      Change password
    </p>

    <form [formGroup]="changePasswordForm" class="w-full grid gap-6 grid-cols-1 mt-12 md:mt-6 mb-12 md:mb-6" action="#">
      <nrc-input-password
        [formControl]="changePasswordForm.controls.newPassword"
        [name]="'change-password-new-password'"
        [id]="'change-password-new-password'"
        [label]="'New password'"
        [classList]="['bg-[#454545]', 'md:bg-neutral-900']"
      />

      <nrc-input-password
        [formControl]="changePasswordForm.controls.newPasswordConfirmation"
        [name]="'change-password-new-password-confirmation'"
        [id]="'change-password-new-password-confirmation'"
        [label]="'Re-enter new password'"
        [classList]="['bg-[#454545]', 'md:bg-neutral-900']"
      />
    </form>

    <div>
      <nrc-password-format-validator [password]="changePasswordForm.controls.newPassword.value" />
    </div>

    <div class="flex justify-end mt-8">
      <button
        type="button"
        class="btn-cyan min-w-[102px]"
        [disabled]="changePasswordForm.invalid"
        (click)="changePassword()"
      >Change password</button>
    </div>
  </div>
</div>
